/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  themas : data.themas
}
const getters = {
  getThemaList: state => {
    return state.themas;
  },
  getThemaById: state => ({ id }) => {
    return selectOne({
      from: state.themas, 
      property: 'id', 
      value: id
    });
  },
  getThemaBySlug: state => ({ slug }) => {
    return selectOne({
      from: state.themas, 
      property: 'slug', 
      value: slug
    });
  }
}


const actions = {}
const mutations = {
  setThemas(state, { dataset }) {
    state.themas = dataset.themas
  }
}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
